import { createSelector } from 'reselect';


export function getEfectores(state) {  
  return state.efectores;
}

export function getEfectorById(state, efectorId) {
  return getEfectores(state).get(efectorId);
}


//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentEfector = createSelector(
  getEfectores,
  efectores => efectores.get(efectores.get('currentEfectorId'))
);
